import React from 'react';

import logoBlue from '../../assets/img/logo/Primary-logo-black.svg';
import logoWhite from '../../assets/img/logo/primary-logo-white.svg';

// mobileHeader: below `sm`, render the logo as a sticky black header with the form in a rounded white sheet (auth flow Figma mobile)
const AuthWrapper = ({ children, authHeading, authSubTitle, stepNavigation, authLogoClass, displayLogo = true, mobileHeader = true }: any) => (
    <>
        <div
            className={`flex h-full bg-white rounded-[20px] lg:rounded-[30px] shadow-lg overflow-hidden ${
                mobileHeader ? 'max-sm:flex-col max-sm:bg-transparent max-sm:rounded-none max-sm:shadow-none' : ''
            }`}
        >
            {mobileHeader && displayLogo && (
                <div className="sm:hidden sticky top-0 z-[1] flex-none bg-utilityBlack px-4 py-[21px]">
                    <img src={logoWhite} alt="logo-white" className="block h-[28px] object-contain" />
                </div>
            )}
            <div
                className={`w-full lg:w-[35%] px-4 overflow-auto custom-scrollbar-v2 flex flex-col scrollbar-hide ${
                    mobileHeader ? 'max-sm:flex-1 max-sm:min-h-0 max-sm:bg-white max-sm:p-5 max-sm:rounded-t-3xl max-sm:shadow-[0px_-1px_13px_5px_rgba(0,0,0,0.08)]' : ''
                }`}
            >
                {displayLogo && (
                    <div className={` pt-[20px] lg:pt-[44px] lg:pl-[28px] ${authLogoClass} sticky top-0 bg-white z-[1] pb-1.5 ${mobileHeader ? 'max-sm:hidden' : ''}`}>
                        <img src={logoBlue} alt="logo-dark" className="max-h-[28px] lg:max-h-[32px] object-contain" />
                    </div>
                )}
                <div className={`max-w-[360px] mx-auto flex flex-col relative justify-start flex-1 w-full ${mobileHeader ? 'max-sm:max-w-none' : ''}`}>
                    {(authHeading || authSubTitle) && (
                        <div className={`flex flex-col gap-y-1 mb-[22px] lg:mb-[32px] mt-[40px] lg:mt-[100px] ${mobileHeader ? 'max-sm:gap-y-0 max-sm:mt-0 max-sm:mb-5' : ''}`}>
                            {authHeading && (
                                <h6
                                    className={`text-grayLight900 text-[22px] lg:text-[30px] leading-[28px] lg:leading-[38px] font-semibold ${
                                        mobileHeader ? 'max-sm:text-[20px] max-sm:leading-[30px]' : ''
                                    }`}
                                >
                                    {authHeading}
                                </h6>
                            )}
                            {authSubTitle && (
                                <p className={`text-grayLight600 text-[12px] lg:text-[14px] leading-[18px] lg:leading-[20px] font-medium ${mobileHeader ? 'max-sm:font-normal' : ''}`}>
                                    {authSubTitle}
                                </p>
                            )}
                        </div>
                    )}
                    {children}
                </div>
                {stepNavigation}
            </div>
            <div className="max-lg:hidden flex-1 bg-[url('../../assets/img/auth-banner.webp')] bg-cover bg-center bg-no-repeat rounded-[30px] flex items-center justify-center relative overflow-hidden after:content-[''] auth-banner-overlay after:h-full after:w-full after:absolute after:top-0 after:left-0 h-full">
                <figure className="z-[1]">
                    <img src={logoWhite} alt="auth-logo" className="xxl:max-w-[460px] max-h-[65px] max-w-[440px] w-full object-contain" />
                </figure>
            </div>
        </div>
    </>
);
export default AuthWrapper;
